import script from "./HiBakeIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HiBakeIndex.vue?vue&type=script&setup=true&lang=js"

import "./HiBakeIndex.vue?vue&type=style&index=0&id=cae141bc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cae141bc"]])

export default __exports__